import { Spin, type SpinProps } from 'antd';
import React from 'react';

import styles from './loader.module.less';

type TProcessingProps = {
  fullscreen?: boolean;
  spinning?: boolean;
  size?: SpinProps['size'];
  description?: string | React.JSX.Element;
};

export const Processing = ({
  fullscreen = true,
  size = 'small',
  spinning = true,
  description,
}: TProcessingProps): React.JSX.Element => (
  <Spin
    className={styles.loader}
    size={size}
    fullscreen={fullscreen}
    spinning={spinning}
    description={description}
  >
    <div />
  </Spin>
);
